import { Component, Input, Renderer2, ViewChild, TemplateRef, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ResetpasswordComponent } from '../resetpassword/resetpassword.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { messageService } from '../message.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() redirectTo: string = "/dashboard"

  orgDetail: any;
  ipAddress: any;
  dialogRef: any;
  snackbarRef: any;

  title = 'angular-demo';
  public href: string = "";
  orgImgDetails: any = {};

  loading: boolean = false;
  isProcessing: boolean = false;
  isShowUserName: boolean = true;
  orgDetailsFound: boolean = false;

  dashboard() {
    this.router.navigate(['/dashboard'])
  }

  constructor(
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
    private readonly message: messageService,
  ) {
    this.appService.connectRedis().subscribe((redis: any) => {
      console.log("REDIS ---- ", redis)
    })
  }

  onLogin() {
    this.appService.getIpAddress().subscribe({
      next: (res) => {
        this.ipAddress = res;   // ✅ correct
        console.log('User IP Address:', this.ipAddress);
      },
      error: (err) => {
        console.error('Error fetching IP address', err);
      }
    });
  }

  ngOnInit() {

    this.href = this.router.url;
    this.createCaptcha();
    this.onLogin();

    let launch_URL: any = {};

    if (location.href == "http://localhost:4200/login") {
      launch_URL = { applicationUrl: "https://predev.one-qms.com/login" }
    } else {
      launch_URL = { applicationUrl: location.href }
    }

    this.loading = true;
    this.appService.orgDetails(launch_URL).subscribe((data: any) => {
      this.message.orgData = this.orgDetail = data;

      if (data) {
        console.log("ORGANIZATION DETAILS → ", data)

        this.orgDetailsFound = true;
        data?.isAllowMobileAccess == 'N' && this.detectDevice();
        this.isShowUserName = data?.hideUserName != "Y";

        this.appService.getAllOrgReportImages().subscribe((response1: any) => {
          this.orgImgDetails = response1;
          console.log("ORGANIZATION IMAGE DETAILS → ", this.orgImgDetails);
        });
      } else {
        this.orgDetailsFound = false;
      }
    });
  }

  private clickListener: () => void;

  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ngOnDestroy() {
    /* Cleaning up the listeners */
    if (this.clickListener) {
      this.clickListener();
    }
  }

  isMobileOrTablet: boolean = false;
  private detectDevice(): void {
    const ua = navigator.userAgent.toLowerCase(); // only userAgent
    const width = window.innerWidth;
    // Detect mobile/tablet via userAgent
    const isMobileUA = /iphone|ipod|android.*mobile|windows phone|blackberry|opera mini|mobile/i.test(ua);
    const isTabletUA = /ipad|android(?!.*mobile)|tablet/i.test(ua);
    // Fallback: screen width (for Desktop site override)
    const isSmallScreen = width <= 1024; // treat widths <=1024px as tablet/mobile
    this.isMobileOrTablet = isMobileUA || isTabletUA || isSmallScreen;
    document.body.style.overflow = this.isMobileOrTablet ? 'hidden' : 'auto';
  }

  showLoginBox = true;
  showRegisterBox = false;
  forgotPasswordBox = false;
  showOrganizationBox = false;

  user_register() {
    this.showLoginBox = false;
    this.showRegisterBox = true;
    this.forgotPasswordBox = false;
  }

  user_login() {
    this.showLoginBox = true;
    this.showRegisterBox = false;
    this.forgotPasswordBox = false;
  }

  forgot_Password() {
    this.forgotPasswordBox = true;
    this.showLoginBox = false;
    this.showRegisterBox = false;
  }

  loginResult: any = {};
  login_to_OneQMS() {

    localStorage.setItem("loginMode", "Editable");
    localStorage.setItem("orgName", this.userSettings['orgName']);

    this.loading = true;
    this.isProcessing = true;
    this.userSettings.tokenId = localStorage.getItem("tokenId") && localStorage.getItem("tokenId") != "undefined" ? localStorage.getItem("tokenId") : null;
    this.userSettings.ipAddress = this.ipAddress;
    console.log("this.ipAddress===" + this.ipAddress);
    const obj = { ...this.userSettings, ...this.message.deviceInfo };
    /*     this.appService.checkSessionExists().subscribe((session: any) => {
          if (session) {
            this.router.navigate(['/dashboard']);
          } else {
            this.appService.loginUser(obj).subscribe((data: any) => {
              this.setupLogin(data);
            })
          }
        }) */

    this.appService.loginUser(obj).subscribe((data: any) => {
      this.setupLogin(data);
    })

  }

  setupLogin(loginResult: any) {
    this.loginResult = loginResult;
    this.parallelSessionAllowed = loginResult.PARALLEL_SESSION_ALLOWED == 'Y';
    this.loading = false;
    this.isProcessing = false;
    this.message.clearcache = loginResult.OP_CLEARCACHE == 'Y';
    this.message.setOrgId(loginResult.IP_ORG_ID);
    if (loginResult.RESULT_TYPE_KEY == 'PW' && loginResult.RESULT_KEY.includes('password expired')) {

      this.dialogRef = this.dialog.open(ResetpasswordComponent, {
        width: '500px',
        data: {
          message: loginResult.RESULT_KEY,
          userDetails: this.userSettings,
          orgId: this.message.getOrgId(),
        }
      });

      this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {
        if (result['event'] == 'add') {
          this.loading = true;
        }
      });
    } else if (loginResult.RESULT_TYPE_KEY == 'ALI') {
      this.visibleSessionAlertPopup = this.dialog.open(this.sessionAlertPopup, this.sessionAlertPopupConfig);
    }
    else if (loginResult.RESULT_TYPE_KEY == 'UW') {
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          message: loginResult.RESULT_KEY,
        }
      });

      this.dialogRef.afterClosed().subscribe((result: { [x: string]: string; }) => {

        if (result['event'] == 'override') {
          this.loading = true;

          this.userSettings.overridesession = "Y";
          this.userSettings.isViewMode = "N";
          this.userSettings.ipAddress = this.ipAddress ?? null;
          this.appService.loginUser(this.userSettings).subscribe((login: any) => {

            if (login.RESULT_TYPE_KEY == 'E') {
              this.showSnackBar(login.RESULT_KEY, loginResult.RESULT_TYPE_KEY);
            }
            else if (login.RESULT_TYPE_KEY == "S") {
              localStorage.setItem("tokenId", loginResult.IOP_TOKEN_ID);
              loginResult.OP_CLEARCACHE == "Y" && (this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig));
              this.setAndRoute();
            }

            this.loading = false;
            this.isProcessing = false;
          })
        } else if (result['event'] == 'view') {

          this.loading = true;
          this.userSettings.overridesession = "N";
          this.userSettings.isViewMode = "Y";
          this.userSettings.ipAddress = this.ipAddress ?? null;
          this.appService.loginUser(this.userSettings).subscribe((login: any) => {

            if (login.RESULT_TYPE_KEY == 'E') {
              this.showSnackBar(login.RESULT_KEY, loginResult.RESULT_TYPE_KEY);
            }
            else if (login.RESULT_TYPE_KEY == "S") {
              localStorage.setItem("tokenId", loginResult.IOP_TOKEN_ID);
              loginResult.OP_CLEARCACHE == "Y" && (this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig));
              this.setAndRoute();
            }

            this.loading = false;
            this.isProcessing = false;
          })
        }
      });
    }
    else if (loginResult.RESULT_TYPE_KEY == 'RE') {
      this.showSnackBar(loginResult.RESULT, 'E');
    }
    else if (loginResult.RESULT_TYPE_KEY == 'E') {
      this.captchaVisible = true;
      this.reloadCaptcha();
      this.showSnackBar(loginResult.RESULT_KEY, loginResult.RESULT_TYPE_KEY);
    }
    else if (loginResult.RESULT_TYPE_KEY == "S") {
      localStorage.setItem("tokenId", loginResult.IOP_TOKEN_ID);
      localStorage.setItem("jwtTokenId", loginResult.jwtToken);
      if (loginResult.OP_CLEARCACHE == "Y") {
        this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
      }
      this.setAndRoute();
    }

  }

  userSettings: any = {
    orgName: null,
    password: null,
    userName: null,
    emailAddress: null,
    overridesession: "N",
    isViewMode: "N",
    tokenId: null,
    ipAddress: null
  }

  setAndRoute() {
    const userName = this.userSettings.userName.toUpperCase()
    this.appService.userDetailsByName(userName).subscribe((data: any) => {
      localStorage.setItem("userName", data[0].userName + ", " + data[0].userName);
      localStorage.setItem("email", data[0].emailAddress);
      this.message.setUserId(data[0].userId);
      localStorage.setItem("userprofilename", data[0].lastName + " , " + data[0].firstName);
      localStorage.setItem("loggedUserName", userName);
      localStorage.setItem("timezone", data[0].timezone);
      localStorage.setItem("loginMode", "Editable");
      localStorage.setItem("adEnabled", "N");

      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
      this.router.navigate(['/dashboard']);
    })
  }

  captchaVisible: boolean = false;
  captchaValidation() {
    if (this.captchaVisible) {
      let result = this.onSubmit();
      if (result) {
        this.login_to_OneQMS();
      } else if (!result && this.captcha_input == "") {
        alert("Please enter the Captcha");
      } else if (!result && this.captcha_input == null) {
        alert("Please enter the Captcha");
      } else if (!result && this.captcha_input == undefined) {
        alert("Please enter the Captcha");
      } else {
        this.captcha_input = "";
        alert("Invalid Captcha")
      }
    } else {
      this.login_to_OneQMS();
    }
  }

  send_forgot_Password() {
    if (!this.userSettings.orgName) {
      this.showSnackBar('Please enter Organization Name', 'E');
    } else if (!this.userSettings.userName) {
      this.showSnackBar('Please enter User Name', 'E');
    } else if (!this.userSettings.emailAddress) {
      this.showSnackBar('Please enter Email Address', 'E');
    } else {
      this.appService.forgotPassword(this.userSettings).subscribe((data: any) => {
        if (data.RESULT_TYPE_KEY == 'S' || data.RESULT_TYPE_KEY == 'E') {
          if (data.RESULT_TYPE_KEY == "S") {
            this.userSettings.userName = null;
            this.userSettings.password = null;
            this.userSettings.emailAddress = null;
            this.userSettings.orgName = null;
          }
          this.showSnackBar(data.RESULT_KEY, data.RESULT_TYPE_KEY);
        }
        this.loading = false;
      })
    }
  }

  onFocusOutEvent(event: any) {
    this.isProcessing = true;
    this.appService.userCount(event.target.value).subscribe((data: any) => {
      this.isProcessing = false;
      if (data > 0 && data > 1) {
        this.showOrganizationBox = true;
      } else {
        this.isProcessing = false;
        this.appService.userOrgName(event.target.value).subscribe((data1: any) => {
          if (data1.length > 0) {
            this.userSettings['orgName'] = data1[0];
          }
        })
        this.showOrganizationBox = false;
      }
    }, () => {
      this.isProcessing = false;
    })
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  isPassword: boolean = true;
  showPassword() {
    this.isPassword = !this.isPassword;
  }

  showUserName() {
    this.isShowUserName = !this.isShowUserName;
  }

  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfirmationPopup: MatDialogRef<TemplateRef<any>>;

  confirmationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  okConfirmation() {
    globalThis.location.reload();
    this.visibleConfirmationPopup.close();
  }

  cancelConfirmation() {
    this.visibleConfirmationPopup.close();
  }

  @ViewChild('sessionAlertPopup', { static: true }) sessionAlertPopup: TemplateRef<any>;
  visibleSessionAlertPopup: MatDialogRef<TemplateRef<any>>;

  sessionAlertPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeSessionAlertPopup() {
    this.visibleSessionAlertPopup.close();
  }


  @Input() config: any = {
    type: 1,
    length: 6,
    cssClass: "custom",
    back: {
      stroke: "#2F9688",
      solid: "#f2efd2",
    },
    font: {
      color: "#000000",
      size: "35px",
    },
  };

  @Output() captchaCode = new EventEmitter();
  captcha_input: any = null;
  code: any = null;
  resultCode: any = null;
  checkCaptchaValue: boolean = false;

  onSubmit() {
    if (this.captcha_input == "" || this.captcha_input !== this.resultCode) {
      return false;
    } else {
      console.log(this.captcha_input, this.resultCode);
      return true;
    }
  }

  checkCaptcha() {
    if (this.captcha_input === this.resultCode) {
      this.checkCaptchaValue = true;
      return true;

    } else {
      this.checkCaptchaValue = false;
      return false;
    }
  }

  createCaptcha() {
    switch (this.config.type) {
      case 1:
        {
          let char =
            Math.random()
              .toString(24)
              .substring(2, this.config.length) +
            Math.random().toString(24).substring(2, 4);
          this.code = this.resultCode = char.toUpperCase();
          break;
        }
      case 2:
    }
    setTimeout(() => {
      let captchaCanvas: any = document.getElementById("captchaCanvas");
      let ctx = captchaCanvas.getContext("2d");
      ctx.fillStyle = this.config.back.solid;
      ctx.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height);

      ctx.beginPath();

      captchaCanvas.style.letterSpacing = 15 + "px";
      ctx.font = this.config.font.size + " " + this.config.font.family;
      ctx.fillStyle = this.config.font.color;
      ctx.textBaseline = "middle";
      ctx.fillText(this.code, 40, 50);
      if (this.config.back.stroke) {
        ctx.strokeStyle = this.config.back.stroke;
        for (let i = 0; i < 150; i++) {
          ctx.moveTo(Math.random() * 300, Math.random() * 300);
          ctx.lineTo(Math.random() * 300, Math.random() * 300);
        }
        ctx.stroke();
      }

    }, 100);
  }

  reloadCaptcha(): void {
    this.createCaptcha();
  }

  parallelSessionAllowed: boolean = false;

  public override() {
    const obj = {
      ...this.message.deviceInfo,
      ...this.userSettings,
      orgId: this.loginResult.IP_ORG_ID,
      userId: this.loginResult.IP_USER_ID,
      tokenId: this.loginResult.IOP_TOKEN_ID,
    }

    this.appService.overrideLogin(obj).subscribe((login: any) => {
      this.visibleSessionAlertPopup.close();
      this.setupLogin(login);
    })

  }
}
